import { useQuery } from "@tanstack/react-query";
import {
	getProductTypesStatisticsData,
	type GetProductTypesStatisticsParams,
} from "../repositories/ProductTypesStatisticsRepository";

type UseProductTypesStatisticsDataParams = Omit<
	GetProductTypesStatisticsParams,
	"signal"
>;

export const useProductTypesStatisticsData = ({
	start,
	end,
}: UseProductTypesStatisticsDataParams) => {
	return useQuery({
		queryKey: ["productTypesStatisticsData", start, end],
		queryFn: ({ signal }) =>
			getProductTypesStatisticsData({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
